import { Link } from 'react-router-dom';

interface Product {
  id: string;
  title: string;
  image: string;
  link: string;
}

const allProducts: Product[] = [
  {
    id: 'fat-burning-kitchen',
    title: 'The Fat Burning Kitchen',
    image: 'https://www.truthaboutabs.com/fbk-physical-2021/images/fbk-intro-img.png',
    link: '/reviews/fat-burning-kitchen-review',
  },
  {
    id: '200-smoothie-recipes',
    title: '200 Delicious Smoothie Recipes',
    image: 'https://200-smoothie-recipes.com/wp-content/uploads/2023/12/200_smoothie_recipes_3D1.png',
    link: '/reviews/200-delicious-smoothie-recipes-review',
  },
  {
    id: '500-dessert-recipes',
    title: '500 Mouthwatering Dessert Recipes',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/bbac0f71c612ecc65aac94f8929a3df7.jpeg',
    link: '/reviews/500-mouthwatering-dessert-recipes-review',
  },
  {
    id: '500-keto-recipes',
    title: '500 Keto Diet Recipes',
    image: 'https://500-keto-recipes.com/wp-content/uploads/2024/09/500-Keto-Clickbank2.png',
    link: '/reviews/500-keto-diet-recipes-review',
  },
  {
    id: '250-vegan-recipes',
    title: '250 Vegan Recipes',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/382c218baff50efb92f4a63cfa3c5fbf.jpeg',
    link: '/reviews/250-vegan-recipes-review',
  },
  {
    id: 'complete-plant-based',
    title: 'The Complete Plant Based Recipe Cookbook',
    image: 'https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/4fcba87dd7223e8afa3935851a860d92.png',
    link: '/reviews/complete-plant-based-cookbook-review',
  },
  {
    id: 'keto-bakery-bundle',
    title: 'Keto Breads & Keto Desserts: Bakery Bundle',
    image: 'https://ketobreads.net/bakery-bundle/assets/images/kb-kd-bundle.png',
    link: '/reviews/keto-bakery-bundle-review',
  },
];

interface RelatedProductsProps {
  currentProductId?: string;
  count?: number;
}

const RelatedProducts = ({ currentProductId, count = 3 }: RelatedProductsProps) => {
  // Filter out current product and get random products
  const availableProducts = allProducts.filter(p => p.id !== currentProductId);
  const shuffled = [...availableProducts].sort(() => Math.random() - 0.5);
  const selectedProducts = shuffled.slice(0, count);

  return (
    <section className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 md:p-8">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
        You May Also Like
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {selectedProducts.map((product) => (
          <Link
            key={product.id}
            to={product.link}
            className="group bg-white rounded-xl overflow-hidden border border-orange-100 hover:border-orange-300 hover:shadow-lg hover:shadow-orange-200/50 transition-all cursor-pointer"
          >
            <div className="aspect-[4/3] overflow-hidden bg-white p-4">
              <img
                src={product.image}
                alt={product.title}
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4 md:p-5">
              <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                {product.title}
              </h3>
              <div className="flex items-center gap-2 text-orange-600 text-sm md:text-base font-medium">
                <span>Read Review</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedProducts;
